import React, { Fragment } from 'react'

import Auth from './routes/Auth/Auth'

const App = () => (
  <Fragment>
    <Auth />
  </Fragment>
)

export default App
